import { LoadingIcon } from '../../../../components/Zen/LoadingIcon';
import styles from './style.m.less';

export const LoadingIndicator = () => (
    <LoadingIcon>
        <g transform="translate(1 3)" fillRule="evenodd">
            <path className={styles.fullBody} d="M15,18v-2c0-2.2-1.8-4-4-4H4c-2.2,0-4,1.8-4,4v2" />
            <path className={styles.halfBody} d="M22,18v-2c0-2.2-1.8-4-4-4h-1" />
            <path
                className={styles.halfHead}
                d="M13.8,0.1C14.1,0,14.3,0,14.5,0c2.2,0,4,1.8,4,4s-1.8,4-4,4c-0.2,0-0.4,0-0.6,0"
            />
            <path
                className={styles.fullHead}
                d="M4.6,6.7C3.9,6,3.5,5,3.5,4c0-2.2,1.8-4,4-4s4,1.8,4,4s-1.8,4-4,4C6.4,8,5.4,7.5,4.6,6.7"
            />
        </g>
    </LoadingIcon>
);
